import React from 'react';
import { motion } from 'framer-motion';
import { Leaf } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-32 pb-20 md:pt-40 md:pb-32 px-6 md:px-12 max-w-5xl mx-auto text-center" data-id="element-103">
      <motion.div initial={{
      opacity: 0,
      scale: 0.9
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.8,
      ease: 'easeOut'
    }} className="absolute top-10 left-1/2 -translate-x-1/2 text-sage opacity-30" data-id="element-104">
        <Leaf size={120} strokeWidth={1} data-id="element-105" />
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6,
      delay: 0.2
    }} className="relative z-10" data-id="element-106">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 text-primary font-medium text-sm mb-8" data-id="element-107">
          <Leaf size={16} data-id="element-108" />
          <span data-id="element-109">The Supplement Blueprint</span>
        </div>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-primary-dark leading-tight mb-8" data-id="element-110">
          Stop Wasting Money on Supplements That Don’t Work
        </h1>

        <p className="text-lg md:text-xl text-charcoal/80 max-w-3xl mx-auto leading-relaxed mb-10" data-id="element-111">
          Discover What to Take, When to Take It, What to Combine, and How to
          Choose High-Quality Supplements That Actually Help Your Body
        </p>

        <a href="#pricing" className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-white bg-primary hover:bg-primary-light transition-colors rounded-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1 duration-200" data-id="element-112">
          Get the Blueprint Now
        </a>
      </motion.div>
    </section>;
}